export default "__VITE_ASSET__aQ4Z2Vtp__"